import React from "react";
import { FullscreenView } from "components/utils/FullscreenView";
import { WindGridHeader } from "components/wind/WindGridHeader";
import { WindGridBody } from "components/wind/WindGridBody";
import { edstFontDim } from "@poscon/shared-frontend";

export const WindGridDisplay = () => (
  <FullscreenView view="WIND" HeaderComponent={WindGridHeader} BodyComponent={WindGridBody} minWidth={edstFontDim.width * 60} />
);
